module.exports = "/_next/static/images/03f5db0c74e027635cf0c694e3f0afc5-phone@2x.png.webp";